<div class="ql-editor text-view" [innerHTML]="textConfiguration.textContent"></div>
